export default {
  STATUS: [
    { KEY: 0, VALUE: 'ATIVA', LABEL: 'Ativa' },
    { KEY: 1, VALUE: 'BLOQUEADA', LABEL: 'Bloqueada' },
  ],
  TYPE: [
    { KEY: 0, VALUE: 'REDE PRÓPRIA' },
    { KEY: 1, VALUE: 'REDE TERCEIRIZADA' },
  ],
  PAYMENT_MODELS: [
    { KEY: 0, VALUE: 'POSPAID', LABEL: 'POS-PAGO' },
    { KEY: 1, VALUE: 'PREPAID', LABEL: 'PRE-PAGO' },
  ],
  OPERATIONS: [
    { KEY: 0, VALUE: 'CREDIT', LABEL: 'CREDITO' },
    { KEY: 1, VALUE: 'DEBIT', LABEL: 'DEBITO' },
  ],
  PAYMENT_METHODS: [
    { KEY: 0, VALUE: 'PIX', LABEL: 'PIX' },
    { KEY: 1, VALUE: 'MONEY', LABEL: 'Dinheiro' },
    { KEY: 2, VALUE: 'CREDIT_CARD', LABEL: 'Cartão de Crédito' },
    { KEY: 3, VALUE: 'DEBIT_CARD', LABEL: 'Cartão de Débito' },
    { KEY: 4, VALUE: 'VOUCHER', LABEL: 'Voucher' },
    { KEY: 5, VALUE: 'REQUISITION', LABEL: 'Requisição' },
    { KEY: 6, VALUE: 'FREE', LABEL: 'Gratuidade' },
    { KEY: 7, VALUE: 'PIX_CONCILIATED', LABEL: 'PIX Conciliado' },
    { KEY: 8, VALUE: 'BALANCE', LABEL: 'saldo em conta' },
  ],
};

const CONST_SELLING_TERMINALS_OBJECT = {
  STATUS: {
    ACTIVE: { KEY: 0, VALUE: 'ATIVA' },
    BLOCKED: { KEY: 1, VALUE: 'BLOQUEADA' },
  },
  TYPE: {
    OWN: { KEY: 0, VALUE: 'REDE PRÓPRIA' },
    EXTERNAL: { KEY: 1, VALUE: 'REDE TERCEIRIZADA' },
  },
};

const REPORT_GROUPINGS = {
  PAYMENT: {
    USED_DATE: 'usedDate',
    AMOUNT: 'amount',
    SUPERVISOR: 'supervisorId',
    EMPLOYEE: 'employeeId',
  },
  TRANSACTION: {
    USED_DATE: 'usedDate',
    TYPE: 'type',
    EMPLOYEE: 'employeeId',
    AMOUNT: 'amount',
    SELLING_POINT: 'sellingPointId',
    SELLING_TERMINAL: 'sellingTerminalId',
    LINE_SECTION: 'lineSectionId',
    QRCODE_TYPE: 'qrcodeType',
    PAYMENT_TYPE: 'paymentType',
  },
};

const GROUP_OPTIONS = [
  { key: 'sellingTerminals', value: 'Agrupando por: Rede de vendas' },
  { key: 'sellingPoints', value: 'Agrupando por: Ponto de Vendas' },
  { key: 'operators', value: 'Agrupando por: Operadores' },
];

const SHIFT_STATUS = [
  { key: 0, value: 'Aberto', color: '#22D76A', open: true },
  { key: 2, value: 'Fechado', color: '#E22020', close: true },
  { key: null, value: 'Criado', color: '#A3BBCC', created: true },
];
const VALIDATE_OPTIONS = [
  { key: 'NÃO VALIDAR', value: 'NÃO VALIDAR' },
  { key: 'AGR', value: 'AGR' },
  { key: 'ONBOARD', value: 'ONBOARD' },
];
const OPTION_NOT_VALIDATE = {
  key: null,
  value: 'NÃO VALIDAR',
};

export {
  CONST_SELLING_TERMINALS_OBJECT,
  REPORT_GROUPINGS,
  GROUP_OPTIONS,
  SHIFT_STATUS,
  VALIDATE_OPTIONS,
  OPTION_NOT_VALIDATE,
};
